const {
  host,
  pathname,
  protocol
} = window.location

const URL = `${ protocol }//${ host }${ pathname }/content.html`

const fetchContent = () => fetch(URL)
  .then(response => response.text())
  .then(html => {
    const node = document.createElement('main')
    node.classList.add('main')
    node.innerHTML = html
    document.body.appendChild(node)
  })

export default fetchContent
